import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getRealtimeHazardEventList = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjghazardevent/getrealtimehazardeventlist' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getRealtimeInquireList = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjghazardevent/getrealtimeinquirelist' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

